import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Dropdown from "rc-dropdown";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../../styles/materialButtonStyle";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";

const ExchangePairsFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("exchangerPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"],
    "inService.name": "",
    "inCurrency.asset": "",
    "outService.name": "",
    "outCurrency.asset": "",
    "percent[gte]": "",
    "percent[lte]": "",
    "constant[gte]": "",
    "constant[lte]": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("pairs.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("pairs.filter.iGive")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <MappedServicesFilter
                checkedService={filterData["inService.name"]}
                setCheckedService={data => handleChangeFilterData(data, "inService.name")}

                checkedCurrency={filterData["inCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "inCurrency.asset")}

                withPaymentSystem={false}
              />
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("pairs.filter.iReceive")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <MappedServicesFilter
                checkedService={filterData["outService.name"]}
                setCheckedService={data => handleChangeFilterData(data, "outService.name")}

                checkedCurrency={filterData["outCurrency.asset"]}
                setCheckedCurrency={data => handleChangeFilterData(data, "outCurrency.asset")}

                withPaymentSystem={false}
              />
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("pairs.filter.percent")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="percent[gte]">
                  {t("pairs.filter.percentFrom")}:
                </label>
                <DelayInput
                  id="percent[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData(
                    { ...filterData, "percent[gte]": event.target.value / 100, page: 1 })}
                  name="percent[gte]"
                  value={filterData["percent[gte]"] * 100}
                  type="number"
                  step={0.1}
                  min={0}
                  max={100}
                  placeholder={t("pairs.filter.example", { value: 20 })}
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="percent[lte]">
                  {t("pairs.filter.percentTo")}:
                </label>
                <DelayInput
                  id="percent[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData(
                    { ...filterData, "percent[lte]": event.target.value / 100, page: 1 })}
                  name="percent[lte]"
                  value={filterData["percent[lte]"] * 100}
                  type="number"
                  step={0.1}
                  min={0}
                  max={100}
                  placeholder={t("pairs.filter.example", { value: 20 })}
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("pairs.filter.constant")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock col="2">
              <StyledFilterGroup>
                <label htmlFor="constant[gte]">
                  {t("pairs.filter.constantFrom")}:
                </label>
                <DelayInput
                  id="constant[gte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "constant[gte]": event.target.value, page: 1 })}
                  name="constant[gte]"
                  value={filterData["constant[gte]"]}
                  type="number"
                  placeholder={t("pairs.filter.example", { value: 20 })}
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="constant[lte]">
                  {t("pairs.filter.constantTo")}:
                </label>
                <DelayInput
                  id="constant[lte]"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "constant[lte]": event.target.value, page: 1 })}
                  name="constant[lte]"
                  value={filterData["constant[lte]"]}
                  type="number"
                  placeholder={t("pairs.filter.example", { value: 200 })}
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("pairs.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ExchangePairsFilter;